import { EventsBySystem, GetEventsByDataSystemsParams } from '@ketch-com/windlass/dist/dataSentry/v1/events/events'
import { API } from 'utils/api/api'
import { formatRequestString } from 'utils/helpers/api/queryString'
import { ControlStatus, AuthorizationStatus } from '@ketch-com/windlass/dist/dataSentry/v1/systems/systems'
//api is used to fetch the data for the systems data grid
export const fetchEventsBySystem = ({
  'start-date': startDate,
  'end-date': endDate,
  'property-codes': propertyCode,
  limit,
  offset,
  query,
  'authorization-status': authorizationStatus,
  'classification-type': classificationType,
  'classification-code': classificationCode,
  'control-status': controlStatus,
}: GetEventsByDataSystemsParams) =>
  API.get<EventsBySystem>(
    formatRequestString({
      entityUrl: `/api/v1/data-sentry/events/by-system`,
      params: {
        filters: {
          ...(startDate
            ? {
                'start-date': startDate,
              }
            : {}),
          ...(endDate
            ? {
                'end-date': endDate,
              }
            : {}),
          ...(propertyCode
            ? {
                'property-codes': propertyCode,
              }
            : {}),
          ...(authorizationStatus
            ? {
                'authorization-status': authorizationStatus,
              }
            : {}),
          ...(authorizationStatus === AuthorizationStatus.AUTHORIZED && controlStatus !== ControlStatus.UNSPECIFIED
            ? {
                'control-status': controlStatus,
              }
            : {}),
          ...(offset
            ? {
                offset,
              }
            : {}),
          ...(limit
            ? {
                limit,
              }
            : {}),
          ...(query
            ? {
                query,
              }
            : {}),
          ...(classificationType
            ? {
                'classification-type': classificationType,
              }
            : {}),
          ...(classificationCode
            ? {
                'classification-code': classificationCode,
              }
            : {}),
        },
      },
    }),
  )
